// Module
var code = "<oc-form name=\"vm.form\"> <amt-content> <amt-row class=\"large-text\">{{'mobileCommon.modulesForUpload' | xlat}}</amt-row> <br/> <div ng-repeat=\"module in vm.initParams.moduleList\"> <ul> <li ng-if=\"module.count\" class=\"large-text\">{{module.description}}</li> </ul> </div> </amt-content> </oc-form>";
// Exports
module.exports = code;